import Vue from 'vue'
import vuetify from './plugins/vuetify'
import './plugins/axios'
import App from './App.vue'
import { registerFilters } from "../helpers/filters";
registerFilters();
import '../../olsStateManagement/css/olsOverride.sass';

Vue.config.productionTip = false

new Vue({
  vuetify,
  render: h => h(App),
}).$mount('.olsAuthentication')
